import { Toro } from '../common/enumerations';
import Units = Toro.Units;
import { ImageManagerService } from '../managers/image-manager.service';
import { ToroControllerBundle } from './toro-controller-bundle';

export class Kd2ControllerBundle extends ToroControllerBundle
{
    constructor(json: any = null, protected imageManager: ImageManagerService)
    {
        super(json, imageManager);

        // if (json)
        // {
        //     // Map the json object to 'this' objects properties.
        //     Object.assign(this, json);
        // }
        //
        // if (json.Controller) this.Controller = new ToroController(json.Controller);
        // if (json.Configuration) this.Configuration = new ToroControllerConfiguration(json.Configuration);
        // if (json.CommCard) this.CommCard = new CommCardDetailed(json.CommCard);

        this. maxStationRuntimeInHours = 4;
        this.Controller.IsControllerSupported = true;
        this.Controller.RunningModeMaxIntervalDays = 7;
        this.maxProgramStartTimeInMinuteOfDay = 32768;
        this.maxTestAllStationsInMins = 9;
        this.showWaterBudgetForProgram = true;
        this.hasSameValuesForWeekdaysAndIntervalDays = true;

        // TODO: The following statement must be removed when the api supports KD2
        this.Configuration.Programs.forEach(program => program.IsEnabled = true);

        this.showClimateLogicSettings = true;
        this.showClimateLogicType = true;
        this.canUpdateNumberOfStations = this.Controller.IsRecognized === false;
        this.showGetControllerConfiguration = true;
        this.showSensorState = true;
        this.treatUnitsAsTemperature = true;

        this.currentIntervalDayLabel = 'Current Skip Day Interval';

        this.updateDryOutDaysList();
        this.updateFreezeOffTemperatureList();
    }

    public supportedLanguages = [
        { Text: 'English', Value: 0 },
        { Text: 'Spanish', Value: 1 },
        { Text: 'French', Value: 2 }
    ];

    public runTimeFormatList = [
        { Text: 'MMM', Value: 0 },
        { Text: 'HH:MM', Value: 1 },
    ];

    public hardwireSensorList = [
        { Text: 'Enabled', Value: true },
        { Text: 'Disabled', Value: false }
    ];

    public units = [
        { Text: 'Metric', Value: 0 },
        { Text: 'English', Value: 1 },
    ];

    updateDryOutDaysList()
    {
        this.dryOutDaysList = [];
        let dryOutValue = 0;
        for (let i = 0; i <= 30; i += 5, dryOutValue += 0.5)
        {
            this.dryOutDaysList.push({ Text: i === 0 ? 'Off' : parseFloat(dryOutValue.toString()).toFixed(1).toString(), Value: i });
        }
    }

    updateFreezeOffTemperatureList()
    {
        this.freezeOffTemperatureList = [];
        if (this.Configuration.Preferences.Units === Units.English)
        {
            for (let i = 29; i <= 45; i += 2)
            {
                this.freezeOffTemperatureList.push({ Text: i.toString(), Value: i });
            }
            return;
        }

        this.freezeOffTemperatureList.push({ Text: '-2', Value: 29 });
        this.freezeOffTemperatureList.push({ Text: '-1', Value: 31 });
        this.freezeOffTemperatureList.push({ Text: '1', Value: 33 });
        this.freezeOffTemperatureList.push({ Text: '2', Value: 35 });
        this.freezeOffTemperatureList.push({ Text: '3', Value: 37 });
        this.freezeOffTemperatureList.push({ Text: '4', Value: 39 });
        this.freezeOffTemperatureList.push({ Text: '5', Value: 41 });
        this.freezeOffTemperatureList.push({ Text: '6', Value: 43 });
        this.freezeOffTemperatureList.push({ Text: '7', Value: 45 });

    }
}
